import React from 'react';
import { Input,Button,Modal, Form } from 'semantic-ui-react';
import { graphql } from '@apollo/client/react/hoc';
import gql from 'graphql-tag';
import {flowRight as compose} from 'lodash';
import {withFormik} from 'formik';
import normalizeErrors from '../normalizeErrors';

const InviteModal = ({
    open,
    onClose,
    values,
    handleChange,
    handleBlur,
    handleSubmit,
    isSubmitting,
    touched,
    errors
  }) => (
    <Modal open={open} onClose={onClose}>
      <Modal.Header>Add members to team</Modal.Header>
      <Modal.Content>
        <Form>
          <Form.Field>
            <Input
              value={values.name}
              onChange={handleChange}
              onBlur={handleBlur}
              name="email"
              fluid
              placeholder="Members Email"
            />
          </Form.Field>
          {touched.email && errors.email}
          <Form.Group widths="equal">
            <Button disabled={isSubmitting} onClick={handleSubmit} fluid>
              Add Member
            </Button>
            <Button disabled={isSubmitting} fluid onClick={onClose}>
              Cancel
            </Button>
          </Form.Group>
        </Form>
      </Modal.Content>
    </Modal>
  );
  
const addTeamMemberMutation = gql`
    mutation($teamId: Int!, $email: String!) {
      addTeamMember(email:$email,teamId:$teamId){
        ok
        errors{
          path
          message
        }
      }
    }
  `;
  export default compose(
    graphql(addTeamMemberMutation),
    withFormik({
      mapPropsToValues: () => ({ email: '' }),
      handleSubmit: async (values, { props: { onClose, teamId, mutate,setErrors }, setSubmitting }) => {

        const response=await mutate({
          variables: { teamId, email: values.email },
        });
        const {ok,errors} = response.data.addTeamMember;
        if(ok){
          onClose();
          setSubmitting(false);
        }else{
          setSubmitting(false);
          setErrors(normalizeErrors(errors));
        }
      },
    }),
  )(InviteModal);
